module.exports = __webpack_public_path__ + "img/government-programme-value4.4c221f21.png";